import { action_options, app_modules } from "helpers/apps_modules_list";
import { Navigate } from "react-router-dom";

// Authentication
import Fourzerofour from "pages/AuthenticationInner/Errors/404Error";
import Fivezerozero from "pages/AuthenticationInner/Errors/500Error";
import Fivezerothree from "pages/AuthenticationInner/Errors/503Error";
import OfflinePage from "pages/AuthenticationInner/Errors/Offline";

import Ecommerce from "pages/Dashboard/Ecommerce";

// Authentication
import ForgotPassword from "pages/Authentication/ForgotPassword";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import Register from "pages/Authentication/Register";
import UserProfile from "pages/Authentication/user-profile";
import Brand from "pages/Master/Brand/Brand";
import BrandDetails from "pages/Master/Brand/BrandDetails";
import BrandForm from "pages/Master/Brand/BrandForm";
import Category from "pages/Master/Category/Category";
import CategoryForm from "pages/Master/Category/CategoryForm";
import CategoryView from "pages/Master/Category/CategoryView";
import Gst from "pages/Master/GST/GST";
import GSTForm from "pages/Master/GST/GSTForm";
import HSNCode from "pages/Master/HSNCode/HSNCode";
import HSNCodeForm from "pages/Master/HSNCode/HSNCodeForm";
import DepartmentForm from "pages/UserManagement/Department/DepartmentForm";
import DeapartmentList from "pages/UserManagement/Department/DepartmentList";
import OrganisationsForm from "pages/UserManagement/Organisations/OrganisationsForm";
import OrganisationsList from "pages/UserManagement/Organisations/OrganisationsList";
import TeamList from "pages/UserManagement/Team/TeamList";
import { default as CreateUserForm, default as UserForm } from "pages/UserManagement/UsersMasters/UserForm";
import UserList from "pages/UserManagement/UsersMasters/UserList";
import UserDetails from "pages/UserManagement/UsersMasters/UserDetails";
import AllRoutes from "./Routes";

import Customer from "pages/Master/Customer/Customer";
import Item from "pages/Master/Items/Item";
import ItemForm from "pages/Master/Items/ItemsForm";
import TeamstForm from "pages/UserManagement/Team/TeamsForms";
import AddUserTypeModal from "pages/UserType/AddUserTypeModal";
import UsersTypeList from "pages/UserType/UserTypeList";
// import BrandForm from "pages/Attributes_Masters/Brand/BrandForm";
import AttributeFForm from "pages/Master/Attributes/AtrributesForm";
import AttributesLList from "pages/Master/Attributes/Attributes";
import ConfigAttributesLList from "pages/Master/Attributes/ConfigAttributes";
import AddCustomerForm from "pages/Master/Customer/AddCustomerForm";
import ViewCustomerDetails from "pages/Master/Customer/CustomerViewDetail";
import ViewItemDetails from "pages/Master/Items/ViewItemDetails";
import TagList from "pages/Master/Tag/Tag";
import TagForm from "pages/Master/Tag/TagForm";
import CreateTemplate from "pages/Template/CreateTemplate";
import Template from "pages/Template/Template";

import TemplateView from "pages/Template/TemplateView";

import ResetPassword from "pages/Authentication/ResetPasswords";
import VerifyOTP from "pages/Authentication/VerifyOTP";
import ConfigAttributesFForm from "pages/Master/Attributes/ConfigAttributesForm";
import WebSyncLog from "pages/Master/Items/WebSyncLog";
import CreateQuotation from "pages/Quotation/Form/CreateQuotation";
import QuotationContainer from "pages/Quotation/List/QuotationContainer";
import ViewQuotationDetails from "pages/Quotation/View/QuotationView";
import ViewTrashQuotationDetails from "pages/Quotation/View/TrashQuotationView";
import ModuleList from "pages/UserManagement/Module/Module";
import AddModuleForm from "pages/UserManagement/Module/ModuleForm";

// import CreateQuotation from "pages/Quotation/Form";

const authProtectedRoutes = [
  // Dashboard
  { 
    path: "/dashboard", 
    component: <Ecommerce />,
  },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  // { path: "*", component: <Navigate to="/dashboard" /> },

  //Masters
  { 
    path: "/category", 
    component: <Category />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options.view
    }
  },
  { 
    path: "/add-category", 
    component: <CategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options.create
    }
  },
  { 
    path: "/edit-category/:id", 
    component: <CategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options.update
    }
  },
  { 
    path: "/category-view/:id", 
    component: <CategoryView />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options.view
    }
  },
  
  // Brand
  { 
    path: "/brand", 
    component: <Brand />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.brand,
      action: action_options.view
    }
  },
  { 
    path: "/add-brand", 
    component: <BrandForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.brand,
      action: action_options.create
    }
  },
  { 
    path: "/edit-brand/:id", 
    component: <BrandForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.brand,
      action: action_options.update
    }
  },
  { 
    path: "/brand-details/:id", 
    component: <BrandDetails />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.brand,
      action: action_options.view
    }
  },
  
  // Sub Category

  { path: "/attribute", component: <AttributesLList /> },
  { path: "/attribute-form", component: <AttributeFForm /> },
  { path: "/attribute-form-edit/:id", component: <AttributeFForm /> },
  { path: "/config-attribute-form/:id", component: <ConfigAttributesFForm /> },
  {
    path: "/config-attribute-form-edit/:id",
    component: <ConfigAttributesFForm />,
  },

  { path: "/attribute-config-form/:id", component: <ConfigAttributesLList /> },

  // GST
  { path: "/gst", component: <Gst /> },
  { path: "/add-gst", component: <GSTForm /> },
  {
    path: "/edit-gst/:id",
    name: "GstEdit",
    component: <GSTForm />,
  },
  {
    path: "/tag",
    name: "Tag",
    component: <TagList />,
  },
  { path: "/add-tag", name: "BrandForm", component: <TagForm /> },
  { path: "/edit-tag/:id", name: "BrandForm", component: <TagForm /> },

  // HSN
  { path: "/hsn-codes", component: <HSNCode /> },
  { path: "/add-hsn-code", component: <HSNCodeForm /> },
  { path: "/edit-hsn-code/:id", component: <HSNCodeForm /> },

  //Item
  { path: "/item", name: "ItemList", component: <Item /> },
  { path: "/add-item", name: "ItemForm", component: <ItemForm /> },
  {
    path: "/view-details/:id",
    name: "ItemDetails",
    component: <ViewItemDetails />,
  },
  {
    path: "/edit-item/:id",
    name: "ItemForm",
    component: <ItemForm />,
  },
  {
    path: "/web-sync-log",
    name: "WebSyncLog",
    component: <WebSyncLog />,
  },


  { path: "/customer", name: "CustomerList", component: <Customer /> },
  {
    path: "/add-customer",
    name: "CustomerList",
    component: <AddCustomerForm />,
  },
  {
    path: "/edit-customer/:id",
    name: "CustomerList",
    component: <AddCustomerForm />,
  },
  {
    path: "/view-customer/:id",
    name: "CustomerList",
    component: <ViewCustomerDetails />,
  },

  //user profile
  { path: "/user-profile", name: "UserProfile", component: <UserProfile /> },

  //for creating new user and listing users
  { 
    path: "/user-list", 
    name: "UserList", 
    component: <UserList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user,
      action: action_options.view
    }
  },
  { 
    path: "/user-form", 
    name: "UserForm", 
    component: <UserForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user,
      action: action_options.create
    }
  },

  // { path: "/user-form/:id", component: <PermissionsTab /> },

  // {
  //   path: "/user-permission",
  //   name: "UserPermission",
  //   component: <PermissionsTab />,
  // },

  {
    path: "/user-form/:id",
    name: "UserForm",
    component: <UserForm />,
  },
  {
    path: "/user-form/:id/permissions",
    name: "UserPermissions",
    component: <UserForm page="permissions" />,
  },
  {
    path: "/user-details/:id",
    name: "UserDetails",
    component: <UserDetails />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user,
      action: action_options.view
    }
  },

  { path: "/user-type", name: "userTypes", component: <UsersTypeList /> },
  {
    path: "/add-usertypes",
    name: "userTypesModules",
    component: <AddUserTypeModal />,
  },
  {
    path: "/add-usertypes/:id",
    name: "userTypesModules",
    component: <AddUserTypeModal />,
  },
  {
    path: "/module-list",
    name: "Module",
    component: <ModuleList />,
  },
  {
    path: "/module-form",
    name: "Module",
    component: <AddModuleForm />,
  },
  {
    path: "/edit-module-form",
    name: "Module",
    component: <AddModuleForm />,
  },
  {
    path: "/organisations-list",
    name: "OrganisationsList",
    component: <OrganisationsList />,
  },
  {
    path: "/organisation-form",
    name: "Organisations",
    component: <OrganisationsForm />,
  },
  {
    path: "/edit-organisation/:id",
    name: "EditOrganisation",
    component: <OrganisationsForm />,
  },

  //for creating department and listing departments
  {
    path: "/department-list",
    name: "DepartmentList",
    component: <DeapartmentList />,
  },
  { path: "/department-form", name: "UserForm", component: <DepartmentForm /> },
  {
    path: "/department-form/:id",
    name: "Department",
    component: <DepartmentForm />,
  },

  //for creating team and listing teams
  { path: "/team-list", name: "TeamList", component: <TeamList /> },
  { path: "/team-forms", name: "UserForm", component: <TeamstForm /> },
  { path: "/team-forms/:id", name: "UserForm", component: <TeamstForm /> },

  {
    path: "/",
    exact: true,
    name: "Navigate",
    component: <Navigate to="/dashboard" />,
  },

  //*// Template
  {
    path: "/template",
    name: "Template",
    component: <Template />,
    permissions: {
      app_name: app_modules.template.app_name,
      module_name: app_modules.template.modules.template,
      action: action_options.view
    }
  },
  {
    path: "/add-template",
    // exact: true,
    name: "AddTemplate",
    component: <CreateTemplate />,
    permissions: {
      app_name: app_modules.template.app_name,
      module_name: app_modules.template.modules.template,
      action: action_options.create
    }
  },
  {
    path: "/edit-template/:id",
    // exact: true,
    name: "EditTemplate",
    component: <CreateTemplate />,
    permissions: {
      app_name: app_modules.template.app_name,
      module_name: app_modules.template.modules.template,
      action: action_options.update
    }
  },
  {
    path: "/view-template/:id",
    // exact: true,
    name: "TemplateDetails",
    component: <TemplateView />,
    permissions: {
      app_name: app_modules.template.app_name,
      module_name: app_modules.template.modules.template,
      action: action_options.view
    }
  },

  // Quotation
  {
    path: "/quotation",
    // exact: true,
    name: "Quotation",
    component: <QuotationContainer />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.quotation,
      action: action_options.view
    }
  },
  {
    path: "/add-quotation",
    // exact: true,
    name: "AddQuotation",
    component: <CreateQuotation />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.quotation,
      action: action_options.create
    }
  },
  {
    path: "/edit-quotation/:id",
    // exact: true,
    name: "EditQuotation",
    component: <CreateQuotation />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.quotation,
      action: action_options.update
    }
  },
  {
    path: "/view-quotation/:id",
    // exact: true,
    name: "TemplateDetails",
    component: <ViewQuotationDetails />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.quotation,
      action: action_options.view
    }
  },
  {
    path: "/view-trash-quotation/:id",
    // exact: true,
    name: "TemplateDetails",
    component: <ViewTrashQuotationDetails />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.quotation,
      action: action_options.view
    }
  },
  ...AllRoutes,
];

const publicRoutes = [
  // Authentication
  { path: "/login", name: "Login", component: <Login /> },
  { path: "/logout", name: "Logout", component: <Logout /> },
  { path: "/register", name: "Register", component: <Register /> },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: <ForgotPassword />,
  },

  // Users Masters for creating new user

  {
    path: "/create-users",
    name: "Ecommerce Create Product",
    component: <CreateUserForm />,
  },
  // Error 404
  { path: "/auth-404", name: "Fourzerofour", component: <Fourzerofour /> },
  // Authentication
  { path: "/login", name: "Login", component: <Login /> },
  { path: "/logout", name: "Logout", component: <Logout /> },
  { path: "/register", name: "Register", component: <Register /> },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: <ForgotPassword />,
  },
  {
    path: "/verify-otp",
    name: "ForgotPassword",
    component: <VerifyOTP />,
  },
  {
    path: "/reset-password",
    name: "ForgotPassword",
    component: <ResetPassword />,
  },

  // Error
  // Error 404
  { path: "/auth-404", name: "Fourzerofour", component: <Fourzerofour /> },

  // Error 500
  { path: "/auth-500", name: "Fivezerozero", component: <Fivezerozero /> },

  // Error 503
  { path: "/auth-503", name: "Fivezerothree", component: <Fivezerothree /> },

  // Offline Page
  { path: "/auth-offline", name: "OfflinePage", component: <OfflinePage /> },
  //{path: "/user-details", name: "Userdetails", component: <UserForm />},
];

export { authProtectedRoutes, publicRoutes };

